import React, { FC } from 'react';

import { Center, SimpleGrid, Text } from '@chakra-ui/react';

import { ordersFilters } from '../StatCards/settings';

import { DateStatus } from 'types/items';
import { DateStatCardProps } from './DateStatCard.props';

const DateStatCardView: FC<DateStatCardProps> = (props) => {
  const { status, onStatusClick } = props;

  return (
    <SimpleGrid mb={6} spacing={5} columns={4} maxW="800px">
      {ordersFilters.map((item) => {
        const _status = DateStatus[item.statusID]?.toLowerCase();

        return (
          <Center
            h="50px"
            shadow="sm"
            border="0.5px solid #ccc"
            bg={status === _status ? item.bg : '#fff'}
            cursor="pointer"
            color={item.color}
            borderRadius="10px"
            fontWeight="bold"
            key={item.statusID}
            onClick={() => {
              if (status === _status) {
                onStatusClick(undefined as any);
              } else {
                onStatusClick(_status as any);
              }
            }}>
            <Text fontSize="15px" textTransform="capitalize">
              {_status}
            </Text>
          </Center>
        );
      })}
    </SimpleGrid>
  );
};

export default DateStatCardView;
